import JSPDF from "jspdf";
import firebase from "firebase/compat/app";

export async function generatePDFRechnungToLink(item, kasse, bbr, settings, verbindung) {
  const rechnung = item;
  const doc = new JSPDF({ orientation: "p", unit: "mm", format: "a4" });
  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginLeft = 20;
  let zeile = 130;

  const pages = [];

  // Header
  function drawHeader(page = 1) {
    doc.setFont("Times");

    if (page === 1) {
      // 🔁 Ursprünglicher Header (komplett)
      doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
      doc.rect(0, 90, 210, 1, "F");

      doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
      doc.rect(0, 91, 210, 1, "F");

      doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
      doc.rect(0, 92, 210, 1, "F");

      const img = new Image();
      img.src = verbindung === "cp" ? "/static/cp/wappen_256.png" : "/static/wappen_256.png";
      doc.addImage(img, 125, 30, 75, 75);

      doc.setFontSize(9);
      doc.text(
        `${settings.name} | ${settings.strasse} ${settings.hausnummer} | ${settings.plz} ${settings.ort}`,
        25,
        51
      );

      doc.setFontSize(11);
      doc.text(`${bbr.anrede}${bbr.titel ? " " + bbr.titel : ""}`, 25, 61);
      doc.text(`${bbr.vorname || "-"} ${bbr.nachname || "-"}`, 25, 66);
      doc.text(bbr.adresse || "-", 25, 71);
      doc.text(`${bbr.plz || "-"} ${bbr.ort || "-"}`, 25, 76);
      doc.text(bbr.land || "-", 25, 81);

      doc.setFont("Times", "bold");
      doc.text("Rechnungsnr.", 20, 110);
      doc.text("Datum", 70, 110);
      doc.text(rechnung.rechnung_art === "SEPA" ? "Einzug am" : "Zahlbar bis", 120, 110);
      doc.text("Kasse", 170, 110);

      doc.setFont("Times", "normal");
      doc.text(rechnung.rechnungsnummer, 20, 115);
      doc.text(new Date(rechnung.rechnung_datum).toLocaleDateString("de-DE"), 70, 115);
      doc.text(new Date(rechnung.rechnung_zahlbar_bis).toLocaleDateString("de-DE"), 120, 115);
      doc.text(rechnung.kasse, 170, 115);
    } else {
      // 🔁 Schmaler Header für Folgeseiten
      doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
      doc.rect(0, 30, 210, 1, "F");

      doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
      doc.rect(0, 31, 210, 1, "F");

      doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
      doc.rect(0, 32, 210, 1, "F");

      const img = new Image();
      img.src = verbindung === "cp" ? "/static/cp/wappen_256.png" : "/static/wappen_256.png";
      doc.addImage(img, 160, 8, 37.5, 37.5); // kleineres Logo
    }
  }

  const drawFooter = (page, totalPages) => {
    doc.setFontSize(9);
    doc.setTextColor(150);
    if (totalPages > 1) {
      if (page < totalPages) {
        doc.text(`Seite ${page} von ${totalPages}`, pageWidth - marginLeft, pageHeight - 25, { align: "right" });
      } else {
        doc.text(`Seite ${page} von ${totalPages}`, pageWidth - marginLeft, pageHeight - 35, { align: "right" });
      }
    }
  };

  const addPage = () => {
    if (doc.internal.getNumberOfPages() > 0) doc.addPage();
    drawHeader(2);
    zeile = 50;
  };

  drawHeader(1);

  // ✍ Freitext
  const lines1 = doc.splitTextToSize(rechnung.rechnung_freitext, 168);
  for (let i = 0; i < lines1.length; i++) {
    if (zeile >= pageHeight - 35) {
      pages.push(doc.internal.getCurrentPageInfo().pageNumber);
      addPage();
    }
    doc.text(lines1[i], marginLeft, zeile);
    zeile += 6;
  }

  // 📋 Positionen
  zeile += 6;
  doc.setFont("Times", "bold");
  doc.text("Pos", 20, zeile);
  doc.text("Beschreibung", 31, zeile);
  doc.text("Betrag", 190, zeile, { align: "right" });
  zeile += 2;
  doc.setFont("Times", "normal");
  doc.line(20, zeile, 190, zeile);
  zeile += 6;

  let pos = 1;
  let summe = 0;

  for (const position of rechnung.positionen) {
    if (zeile >= pageHeight - 30) {
      pages.push(doc.internal.getCurrentPageInfo().pageNumber);
      addPage();
    }
    doc.text(String(pos), 20, zeile);
    doc.text(position.was, 31, zeile);
    doc.text(`${parseFloat(position.betrag).toFixed(2)} €`, 190, zeile, { align: "right" });
    summe += parseFloat(position.betrag);
    zeile += 10;
    pos++;
  }

  doc.line(20, zeile - 4, 190, zeile - 4);
  doc.setFont("Times", "bold");
  doc.text(`Summe ${summe.toFixed(2)} €`, 190, zeile, { align: "right" });

  // 🦶 Fußbereich
  doc.setFontSize(10);
  doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
  doc.rect(0, 265, 210, 32, "F");
  doc.setFont("Times", "bold");
  doc.setTextColor(230, 230, 230);
  doc.text(settings.name, 60, 272, { align: "center" });
  doc.setFont("Times", "normal");
  doc.text(rechnung.kasse, 60, 280, { align: "center" });
  doc.text(`${settings.strasse} ${settings.hausnummer}`, 60, 285, { align: "center" });
  doc.text(`${settings.plz} ${settings.ort}`, 60, 290, { align: "center" });
  doc.setFont("Times", "bold");
  doc.text("Bankverbindung", 150, 272, { align: "center" });
  doc.setFont("Times", "normal");
  doc.text(kasse.kontoname, 150, 280, { align: "center" });
  doc.text(kasse.IBAN, 150, 285, { align: "center" });
  doc.text(kasse.BIC, 150, 290, { align: "center" });

  // 📄 Seitenzahlen einfügen
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    drawFooter(i, totalPages);
  }

  console.log("Create PDF Rechnung " + rechnung.rechnungsnummer);
  const year = rechnung.rechnungsnummer.split("-")[0];
  const refPath = `rechnungen/${verbindung}/${year}/${rechnung.rechnungsnummer}`;

  return firebase
    .storage()
    .ref(refPath)
    .put(doc.output("blob"))
    .then((snapshot) => snapshot.ref.getDownloadURL());
}



// WEBPACK FOOTER //
// ./src/funktionen/generatePDFRechnungToLink.js